import React, { useState } from 'react';
import { Counter } from '../components';
import veg from '../../assets/icons/veg.png';
import nonveg from '../../assets/icons/non-veg.png';

import styles from './menuCard.module.css';
import { printCurrencySymbol } from '../../helpers/commonHelper';
import { useLanguage } from '../../context/LanguageContext';
import { renderPrice } from '../../helper/commonHelper';
import { useHotel } from '../../context/HotelContext';
import {Button} from 'antd';
const MenuCard = ({
    name,
    type,
    price,
    tags,
    description,
    increaseQuantity,
    decreaseQuantity,
    defaultQuantity,
    viewOnly,
}) => {
    const [count, setCount] = useState(defaultQuantity || 0);
    const { hotelDetails } = useHotel();
    const { t } = useLanguage();
    const currentCurrency = printCurrencySymbol(hotelDetails);
    const increment = (newQuantity) => {
        setCount(newQuantity);
        increaseQuantity(newQuantity);
        return;
    };

    const decrement = (newQuantity) => {
        setCount(newQuantity);
        decreaseQuantity(newQuantity);
        return;
    };
    const tagColor =
        hotelDetails.id === 12 ||
        hotelDetails.id === 16 ||
        hotelDetails.id === 204 ||
        hotelDetails.id === 206 ||
        hotelDetails.id === 207 ||
        hotelDetails.id === 208 ||
        hotelDetails.id === 209 ||
        hotelDetails.id === 210 ||
        hotelDetails.id === 332 ||
        hotelDetails.id === 389
            ? ' tag-aqua'
            : hotelDetails.id === 386
            ? ' tag-bg-bronze'
            : '';
    return (
        <article className={styles.menuCard}>
            <div className={styles.addButtonWrapper}>
                {viewOnly && (
                    <span className={styles.price}>
                        {price > 0
                            ? `${currentCurrency} ${renderPrice(
                                  price,
                                  hotelDetails
                              )}`
                            : `  `}
                    </span>
                )}
                {!viewOnly && (
                    <>
                        {count === 0 ? (
                            <Button onClick={() => [setCount(1), increment(1)]}>
                                {t['ird_add_item_btn']}
                            </Button>
                        ) : (
                            <Counter
                                count={count}
                                increment={() => increment(count + 1)}
                                decrement={() => decrement(count - 1)}
                            />
                        )}
                    </>
                )}
            </div>
            <div className={styles.dishName}>
                {type === 'veg' && <img src={veg} alt='veg_icon' />}
                {type === 'non_veg' && <img src={nonveg} alt='nonveg_icon' />}

                <h6>{name}</h6>
            </div>
            {!viewOnly && (
                <span className={styles.price}>
                    {price > 0
                        ? `${currentCurrency} ${renderPrice(
                              price,
                              hotelDetails
                          )}`
                        : `  `}
                </span>
            )}
            <span
                className={styles.disclaimerText}
                dangerouslySetInnerHTML={{ __html: description }}
            ></span>
            <div className={'tagcontainer'}>
                {tags &&
                    JSON.parse(tags).map((item) => (
                        <span className={`tag ${tagColor}`}>{item}</span>
                    ))}
            </div>
        </article>
    );
};

export default MenuCard;
